import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { ICheers, IToastCheers } from 'app/models/cheers';
import * as CheersActions from './actions'

export interface State {
  cheers: ICheers[];
  toasts: IToastCheers[];
  error: string;
}

export const initialState: State = {
  cheers: [],
  toasts: [],
  error: '',
};

export const stateName = 'cheers';

const getCheersFeatureState = createFeatureSelector<State>(stateName);

export const selectAllCheers = createSelector(
  getCheersFeatureState,
  state => state.cheers
);

export const selectAllToasts = createSelector(
  getCheersFeatureState,
  state => state.toasts
);

export const selectActiveToast = createSelector(
  selectAllToasts,
  toasts => toasts.length > 0 ? toasts[0] : null
);

export const getCheersForTap = (tapId: string) => createSelector(selectAllCheers, items => items.find(x => x.id === tapId));

export const reducer = createReducer<State>(
  initialState,
  on(
    CheersActions.upsertOneCheers, (state, action): State => {
      return {
        ...state,
        cheers: [action.tap] // NOTE: Is this meant to just replace the whole array? Keeping what was there.
      }
    }
  ),
  on(
    CheersActions.addToast, (state, { toast }): State => ({
      ...state,
      toasts: [...state.toasts, toast]
    })
  ),
  on(
    CheersActions.removeToast, (state, { id }): State => ({
      ...state,
      toasts: state.toasts.filter(t => t.id !== id)
    })
  )
);
